// extracted by mini-css-extract-plugin
export default {"video":"style_video__muq53"};